import React from "react";
import { Sun, Moon } from "@phosphor-icons/react";
import { useTheme } from "../context/ThemeContext";

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      onClick={toggleTheme}
      data-testid="theme-toggle"
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      className="relative w-9 h-9 rounded-full border border-[color:var(--border-strong)] flex items-center justify-center text-[color:var(--accent)] hover:border-[color:var(--accent)] transition-all duration-300 group overflow-hidden"
    >
      <span
        className={`absolute inset-0 flex items-center justify-center transition-all duration-500 ${
          isDark ? "opacity-100 rotate-0" : "opacity-0 -rotate-90"
        }`}
      >
        <Moon size={16} weight="light" />
      </span>
      <span
        className={`absolute inset-0 flex items-center justify-center transition-all duration-500 ${
          isDark ? "opacity-0 rotate-90" : "opacity-100 rotate-0"
        }`}
      >
        <Sun size={16} weight="light" />
      </span>
    </button>
  );
}
